export default {
  id: 'teams_schedule_jobs',
  title: 'Schedule jobs',
  type: 'Direct',
  relations: [ 'MANY_JOBS' ],
  description: 'Send a call to action button of up to 4 selected jobs to your employees so they can easily schedule to share them actross their network.',
  body: `<div>
    <p>[[INPUT_SHARE_SCHEDULE_TEXT]]</p>
    <div style='display: inline-block; margin: 0px'>
      <a style='display: inline-block; color:#333' href='{{JOB_LINKEDIN_SCHEDULE_LINK}}'>
      <pre style='background-color: #e6e6e6; border-radius: 4px; padding-up:0px; padding-right:6px; padding-left:6px; margin-right:10px'>Schedule LinkedIn Posts</pre>
      </a>
    </div>
    <p>[[INPUT_END_TEXT]]</p>
  </div>`.split('\n').map(line => line.trim().replaceAll('\n', '')).join(''),
  inputs: {
    INPUT_SHARE_SCHEDULE_TEXT: {
      label: 'Schedule',
      placeholder: 'Schedule your job shares to go out at the best times for your network ...',
      defaultValue: 'Schedule your job shares to go out at the best times for your network and win some awesome rewards.',
      type: 'HTML'
    },
    INPUT_END_TEXT: {
      label: 'Text at the end',
      placeholder: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}...',
      defaultValue: 'Come back to the platform to get more rewards by every action you take! {{PLATFORM_LINK}}',
      type: 'HTML'
    }
  }
};


// WEBPACK FOOTER //
// ./src/views/campaign-admin/templates/teams/scheduleJobs.js